import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useSelector } from "react-redux";

import { selectorSystemIsTopPanelVisible } from "@/shared/store/system/selectors";
import { EL_ID_TOP_PANEL } from "@/components/TopPanel/TopPanel.constants";

import styles from "./top-panel.module.scss";

const TopPanel = ({ className, children }) => {
  const isTopPanelVisible = useSelector(selectorSystemIsTopPanelVisible);

  return (
    <div id={EL_ID_TOP_PANEL} className={classNames(className, styles["top-panel"], {
      [styles["hidden"]]: !isTopPanelVisible,
    })}>
      {children}
    </div>
  );
};

TopPanel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
};

export default TopPanel;
